import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss'],
})
export class TabsPage {
  constructor(private router: Router) {}

  isHomeActive(): boolean {
    return this.router.url === '/home' || this.router.url === '/';
  }

  isEventActive(): boolean {
    return this.router.url === '/events';
  }

  isWalletActive(): boolean {
    return this.router.url === '/wallets';
  }

  isRewardsActive(): boolean {
    return this.router.url === '/rewards';
  }

  isProfileActive(): boolean {
    return this.router.url === '/profile';
  }
}
